// components/Testimonials.jsx
import React from "react";
import "./Testimonials.css";
import { Quote } from "lucide-react";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Ramesh Subramani",
      company: "A2Cakes",
      text: "KadaiPOS transformed our business. We've seen a 30% increase in sales since implementation thanks to the powerful analytics and customer management features.",
      rating: 5,
      initials: "RS",
    },
    {
      name: "Sathish Kumar",
      company: "Restaurant Owner",
      text: "The inventory management alone is worth the price. We've reduced our stockouts by 85% and improved our inventory turnover ratio significantly.",
      rating: 5,
      initials: "SK",
    },
    {
      name: "Gokul",
      company: "GB Cakes",
      text: "Customer support is incredible. They helped us set up everything perfectly and were available 24/7 during our transition period. Couldn't be happier!",
      rating: 5,
      initials: "G",
    },
  ];

  return (
    <section id="testimonials" className="section testimonials-section">
      <div className="container">
        <h2 className="section-title">
          Loved by <span className="gradient-text">Business Owners</span>
        </h2>
        <p className="section-subtitle">
          Join hundreds of satisfied food business owners who have transformed
          their operations with KadaiPOS.
        </p>

        <div className="testimonials__grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonials__card glass-card">
              <Quote
                size={32}
                className="testimonials__quote-icon"
              />

              <div className="testimonials__stars">
                {"★".repeat(testimonial.rating)}
              </div>

              <p className="testimonials__text">"{testimonial.text}"</p>

              <div className="testimonials__author">
                <div className="testimonials__avatar">
                  {testimonial.initials}
                </div>
                <div>
                  <strong className="testimonials__name">
                    {testimonial.name}
                  </strong>
                  <span className="testimonials__company">
                    {testimonial.company}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;